<section class="quotation-main-section with-less-bg create-project m-quote-container m-quote-content-scroll">
  <div class="inner-box">
    <div class="form-box">
      <div class="form-heading">
        <img class="logo" [src]="getImagePath+'create-project-logo.svg'" alt="Logo" width="32px" height="32px">
        <h1 class="heading-1">Create PCBA Quote</h1>
      </div>

      <form class="custom-create-project-form " id="createProjectForm" [formGroup]="createProjectForm"
        (ngSubmit)="CreateProject()">
        <div class="form-control-box bottom-spacing">
          <label for="name" class="label">Project Name<span class="text-danger">*</span></label>
          <div>
            <mat-form-field appearance="outline" class="improved-input w-100 m-quote">
              <input matInput id="name" placeholder="Enter Project Name" formControlName="name"
              (input)="CheckIfInvalid()">
            </mat-form-field>
          </div>
          <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
            class="input-details-box no-mat-input justify-content-end">
            <mat-error class="w-100 increase-z-index error-top-spacing error-message"
              *ngIf="hasError(createProjectForm, 'name', 'required')">
              Project Name is required.
            </mat-error>
            <mat-error class="w-100 increase-z-index error-top-spacing error-message"
              *ngIf="hasError(createProjectForm, 'name', 'maxlength')">
              Must not exceed 100 characters.
            </mat-error>
            <mat-error class="w-100 increase-z-index error-top-spacing error-message"
              *ngIf="hasError(createProjectForm, 'name', 'pattern')">
              Please enter valid name.
            </mat-error>
          </div>
        </div>
        <div class="form-control-box bottom-spacing">
          <label for="description" class="label">Description<span class="text-danger">*</span></label>
          <div>
            <mat-form-field appearance="outline" class="improved-textarea">
              <textarea matInput rows="5" cdkTextareaAutosize id="description" placeholder="Write Description"
              formControlName="description" (input)="CheckIfInvalid()" #input></textarea>
          </mat-form-field>
          </div>
          <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
            class="input-details-box no-mat-input justify-content-end">
            <mat-error class="w-100 increase-z-index error-top-spacing error-message"
              *ngIf="hasError(createProjectForm, 'description', 'required')">
              Project Description is required!
            </mat-error>
            <mat-error class="w-100 increase-z-index error-top-spacing error-message"
              *ngIf="hasError(createProjectForm, 'description', 'maxlength')">
              Must not exceed 1000 characters!
            </mat-error>
            <mat-error class="w-100 increase-z-index error-top-spacing error-message"
              *ngIf="hasError(createProjectForm, 'description', 'pattern')">
              Please enter valid name.
            </mat-error>
          </div>
        </div>
        <!-- <div class="form-control-box bottom-spacing">
          <label class="label">Select a Project Type<span class="text-danger">*</span></label>
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            formControlName="type" (change)="onSelectionChange($event)">
            <mat-radio-button class="example-radio-button" *ngFor="let project of projectOptions" [value]="project.id">
              {{project.name}}
            </mat-radio-button>
          </mat-radio-group>
          <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
            class="input-details-box no-mat-input justify-content-end">
            <mat-error class="w-100 increase-z-index error-top-spacing error-message"
              *ngIf="hasError(createProjectForm, 'type', 'required')">
              Project Type is required!
            </mat-error>
          </div>
        </div> -->
        <div class="flex-box">
          <button type="submit" class="btn btn-primary improved-add-btn">Next</button>
        </div>
      </form>
    </div>
  </div>
</section>